import React, { useEffect, useState, useRef } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Sale_Fps from './Sales_Fps';

const SaleAfso_data = async (parms) => {
  const response = await fetch(`${process.env.REACT_APP_URL_SALE}/Sale/Sales_Afso`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(parms),
  });
  if (!response.ok) {
    throw new Error('Failed to fetch data');
  }
  return response.json();
};

const Sale_Afso = ({ month, year, dist_code }) => {
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tabHeading, setTabHeading] = useState("");
  const fpstab = useRef(null);
  const [renderContenttttt, setRenderContenttttt] = useState(null);
  const [dataTime, setDataTime] = useState("");
  const details3 = useRef(null);
  const tableRef = useRef(null);

  const handleAfsoClick = (month, year, dist_code, afso_code) => {
    setRenderContenttttt(null);
    setTimeout(() => {
      setRenderContenttttt(
        <Sale_Fps
          month={month}
          year={year}
          dist_code={dist_code}
          afso_code={afso_code}
        />
      );
    }, 10);
  };

  const handleDownload = () => {
    const tableSelect = tableRef.current;
    if (!tableSelect) return;

    const dataType = 'application/vnd.ms-excel';
    const tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');
    const downloadLink = document.createElement('a');
    document.body.appendChild(downloadLink);

    downloadLink.href = 'data:' + dataType + ', ' + tableHTML;
    downloadLink.download = 'sale_office.xls';
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  useEffect(() => {
    const getData = async () => {
      try {
        setLoading(true);
        const response_data = await SaleAfso_data({ month, year, dist_code });
        setTabHeading(response_data.heading || "");

        if (response_data.data && response_data.data.length > 0) {
          const data = response_data.data;
          setReportData(data);

          const dTimeItem = data.find(item => item.data_time || item.DATA_TIME || item.datatime);
          let dTime = dTimeItem ? (dTimeItem.data_time || dTimeItem.DATA_TIME || dTimeItem.datatime) : "";
          if (dTime) {
            try {
              const date = new Date(dTime);
              if (!isNaN(date.getTime())) {
                const day = String(date.getDate()).padStart(2, '0');
                const monthVal = String(date.getMonth() + 1).padStart(2, '0');
                const yearVal = date.getFullYear();
                let hours = date.getHours();
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                const ampm = hours >= 12 ? 'PM' : 'AM';
                hours = hours % 12 || 12;
                const strHours = String(hours).padStart(2, '0');
                dTime = `${day}-${monthVal}-${yearVal} ${strHours}:${minutes}:${seconds} ${ampm}`;
              }
            } catch (e) {
              dTime = dTime.replace('T', ' ').substring(0, 19);
            }
          }
          setDataTime(dTime);
        } else {
          setReportData([]);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    getData();
  }, [month, year, dist_code]); // dependencies updated

  useEffect(() => {
    if (!loading && !error && reportData.length > 0 && fpstab.current) {
      fpstab.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [loading, error, reportData]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
        <Box sx={{ display: 'flex' }}>
          <CircularProgress />
        </Box>
      </div>
    );
  }

  if (error) {
    return <div className="mainhead" align="center">Internal Error: {error}</div>;
  }

  if (reportData.length === 0) {
    return <div className="mainhead" align="center">No data found</div>;
  }

  //  unique commodity names
  const uniqueCommNames = Array.from(new Set(
    reportData[0].commodityList.map(c => c.comm_name_en)
  ));

  // data
  const processedRows = reportData.map(item => {
    const commAggregation = {};
    uniqueCommNames.forEach(name => { commAggregation[name] = { nfsa: 0, state: 0 }; });

    item.commodityList.forEach(c => {
      if (commAggregation[c.comm_name_en]) {
        commAggregation[c.comm_name_en].nfsa += Number(c.nfsasaleQty || 0);
        commAggregation[c.comm_name_en].state += Number(c.statesaleQty || 0);
      }
    });

    return { ...item, commAggregation };
  });

  const grandTotals = processedRows.reduce((acc, row) => {
    acc.nfsa_cards += row.nfsa_cards || 0;
    acc.state_cards += row.state_cards || 0;
    acc.total_cards += row.total_cards || 0;
    acc.aay_cards += row.aay_cards || 0;
    acc.phh_cards += row.phh_cards || 0;
    acc.bpl_cards += row.bpl_cards || 0;
    acc.totalNFSA_Avail += row.totalOfaay_cardsPhh_cardsBpl_cards || 0;
    acc.nph_cards += row.nph_cards || 0;

    uniqueCommNames.forEach(name => {
      acc.commTotals[name].nfsa += row.commAggregation[name].nfsa;
      acc.commTotals[name].state += row.commAggregation[name].state;
    });
    return acc;
  }, {
    nfsa_cards: 0, state_cards: 0, total_cards: 0, aay_cards: 0, phh_cards: 0, bpl_cards: 0,
    totalNFSA_Avail: 0, nph_cards: 0,
    commTotals: uniqueCommNames.reduce((obj, name) => ({ ...obj, [name]: { nfsa: 0, state: 0 } }), {})
  });

  return (
    <div ref={fpstab}>
      <div style={{ overflowX: 'auto', width: '100%', margin: '0 auto' }}>
        <table ref={tableRef} align="center" width="98%" border={1} id="SucessReport">
          <thead>
            <tr className="tableheader">
              <th colSpan={12 + (uniqueCommNames.length * 3)}>
                {tabHeading}
              </th>
            </tr>
            <tr className="tableheader">
              <td rowSpan="3">Sl No</td>
              <td rowSpan="3">Office</td>
              <td colSpan="3">Total Cards</td>
              <td colSpan="7">Availed Cards</td>
              <td colSpan={uniqueCommNames.length * 3}>Availed Qty(Kgs)</td>
            </tr>
            <tr className="tableheader">
              <td rowSpan="2"> NFSA<br /><font style={{ color: "orange" }}>(A)</font></td>
              <td rowSpan="2">STATE<br /><font style={{ color: "orange" }}>(B)</font></td>
              <td rowSpan="2">Total<br /><font style={{ color: "orange" }}>(C=A+B)</font> </td>
              <td colSpan="4">NFSA</td>
              <td colSpan="1">STATE<br /><font style={{ color: "orange" }}>(E)</font></td>
              <td rowSpan="2">Total<br /> <font style={{ color: "orange" }}>(F=D+E)</font> </td>
              <td rowSpan="2">NFSA Avail %<br /> <font style={{ color: "orange" }}> (D*100/A)</font></td>
              <td colSpan={uniqueCommNames.length}>NFSA<br /><font style={{ color: "orange" }}>(X)</font> </td>
              <td colSpan={uniqueCommNames.length} >STATE<br /><font style={{ color: "orange" }}>(Y)</font> </td>
              <td colSpan={uniqueCommNames.length}>Total<br /><font style={{ color: "orange" }}>(Z=X+Y)</font> </td>
            </tr>
            <tr className="tableheader">
              <td>AAY</td><td>PHH</td><td>BPL</td><td>Total<br /><font style={{ color: "orange" }}>(D)</font></td>
              <td>NPH</td>
              {uniqueCommNames.map(name => <td key={`h1-${name}`}>{name}</td>)}
              {uniqueCommNames.map(name => <td key={`h2-${name}`}>{name}</td>)}
              {uniqueCommNames.map(name => <td key={`h3-${name}`}>{name}</td>)}
            </tr>
          </thead>
          <tbody>
            {processedRows.map((item, index) => (
              <tr key={item.afso_code || index}>
                <td align="center">{index + 1}</td>
                <td align="left">
                  <a style={{ cursor: 'pointer', color: 'blue' }} onClick={() => handleAfsoClick(month, year, item.dist_code, item.afso_code)}>
                    {item.afso_name_en}
                  </a>

                </td>
                <td align="right">{item.nfsa_cards}</td>
                <td align="right">{item.state_cards}</td>
                <td align="right">{item.total_cards}</td>
                <td align="right">{item.aay_cards}</td>
                <td align="right">{item.phh_cards}</td>
                <td align="right">{item.bpl_cards}</td>
                <td align="right">{item.totalOfaay_cardsPhh_cardsBpl_cards}</td>
                <td align="right">{item.nph_cards}</td>
                <td align="right">{item.totalOfaay_cardsPhh_cardsBpl_cards + item.nph_cards}</td>
                <td align="right">{item.nfsaAvgPercentage}</td>
                {uniqueCommNames.map(name => (
                  <td key={`nfsa-${name}`} align="right">{item.commAggregation[name].nfsa.toFixed(3)}</td>
                ))}
                {uniqueCommNames.map(name => (
                  <td key={`state-${name}`} align="right">{item.commAggregation[name].state.toFixed(3)}</td>
                ))}
                {uniqueCommNames.map(name => (
                  <td key={`total-${name}`} align="right">{(item.commAggregation[name].nfsa + item.commAggregation[name].state).toFixed(3)}</td>
                ))}
              </tr>
            ))}
            <tr className="tableheader" style={{ fontWeight: 'bold' }}>
              <td colSpan={2} align="right">Total:</td>
              <td align="right">{grandTotals.nfsa_cards}</td>
              <td align="right">{grandTotals.state_cards}</td>
              <td align="right">{grandTotals.total_cards}</td>
              <td align="right">{grandTotals.aay_cards}</td>
              <td align="right">{grandTotals.phh_cards}</td>
              <td align="right">{grandTotals.bpl_cards}</td>
              <td align="right">{grandTotals.totalNFSA_Avail}</td>
              <td align="right">{grandTotals.nph_cards}</td>
              <td align="right">{grandTotals.totalNFSA_Avail + grandTotals.nph_cards}</td>
              <td align="right">{grandTotals.nfsa_cards > 0 ? (grandTotals.totalNFSA_Avail * 100 / grandTotals.nfsa_cards).toFixed(2) : "0.00"}</td>
              {uniqueCommNames.map(name => <td key={`t1-${name}`} align="right">{grandTotals.commTotals[name].nfsa.toFixed(3)}</td>)}
              {uniqueCommNames.map(name => <td key={`t2-${name}`} align="right">{grandTotals.commTotals[name].state.toFixed(3)}</td>)}
              {uniqueCommNames.map(name => <td key={`t3-${name}`} align="right">{(grandTotals.commTotals[name].nfsa + grandTotals.commTotals[name].state).toFixed(3)}</td>)}
            </tr>
          </tbody>
        </table>
      </div>

      <div align="center" style={{ marginTop: '20px' }}>
        <button type="button" className="button button2" onClick={handleDownload}>Data to Excel</button>
      </div>
      {dataTime && (
        <div style={{ width: "98%", textAlign: 'right', margin: '10px auto 0', fontWeight: 'bold' }}>
          Last Refresh Time: {dataTime}
        </div>
      )}
      <br />
      <div id='detailsRR' ref={details3}>{renderContenttttt}</div>
    </div>
  );
};

export default Sale_Afso;